import { formatMensagemErroExibicao } from '../../common/utils/erroMensagemUtils';

export function formatNotificationMessage(mensagem) {
  return formatMensagemErroExibicao(mensagem);
}
